import React, { useState } from "react";
import { upload_document_v2 } from "./Company_capital_increases";
import { useForm } from "react-hook-form";
import { v4 as uuidv4 } from "uuid";
import FormNewPayment from "../../../../../components/common/forms/FormNewPayment";
import Documents from "../../../../../components/common/forms/Documents";
import FormButtom from "../../../../../components/common/forms/FormButtom";
import ReusableNewCompany from "../common/ReusableNewCompany";
import FormBranch from "../../../../../components/common/forms/FormBranch";
import api from "../../../../../api/api";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import AdminSearchCustomer from "../../../common/AdminSearchCustomer";
import NewFormPayment from "../../../../../components/common/forms/NewFormPayment";


const NewCmpCapital = () => {
  const { register, handleSubmit } = useForm();
  const [docsOutput, setDocsOutput] = useState([]);
  const [uploadProof, setUploadProof] = useState('')
  const { user, isSuccess } = useSelector((state) => state.auth);
  const [userID, setUserId] = useState(null)

  const handleSub = (data) => {
    data.documents = docsOutput;

    if (user?.user_type === "CL") {
      const user = JSON.parse(localStorage.getItem("user"));
      data.user = user.user_id;
    } else {
      if (userID !== null) {
        data.user = userID
      }
    }

    api
      .post(`services/company/`, data)
      .then((response) => {
        toast.success("Data Registered Successfully")

        // let transactions = {
        //   // payment_mode: "e_wallet",
        //   amount: 2500,
        //   service_object_id: response.data.registration_id,
        //   created_by: response.data.registration_id,
        //   service_object_content_type: response.data.service_content_type_id,
        //   payment_proof : uploadProof,
        //   company : response.data.company_id,
        //   transaction_type: "credit"

        // };


        // api
        // .post("/transactions/", transactions)
        // .then((response) => {
        //   toast.success("Data Registered 2 Successfully.");
        // })
        // .catch((error) => {
        //   toast.error("Error in Transaction");
        // });
      })

      .catch((error) => {
        // console.log("error", error);
        toast.error("Something went wrong")
      });




  };

  let data_v2 = [];
  upload_document_v2.map((item, i) => {
    data_v2.push({ id: uuidv4(), image: "", document_name: "" });
    return "";
  });

  return (
    <form>
      {/* new company for 3 months */}
      <div className="mt-3">
        {

          (user?.user_type === "ST" || user?.user_type === "AD")
          && <AdminSearchCustomer
            setUserId={setUserId}
          />
        }
      </div>

      <div className="mt-4">
        <ReusableNewCompany register={register} name={true} />
        <div className="flex-col border-2 border-primary-blue flex font-Laila  md:flex-row flex-wrap">
          <div className="flex flex-1  md:border-r border-b md:border-b-0 items-center m-0 px-2 border-primary-blue">
            <label className="border-primary-blue flex-shrink-0 border-l-0 text-primary-red  text-lg font-bold">
              अव बृद्धि हुने अधिकृत पुँजीः
            </label>
            <input
              type="text"
              placeholder=" "
              {...register("paid_up_capital", { required: false })}
              className=" text-primary-blue w-[60%] m-0  py-3 px-3 outline-none"
            />
          </div>
          <div className="flex flex-1 flex-wrap w-fit   md:border-l-0 px-2 items-center border-primary-blue">
            <label className="border-primary-blue flex-shrink-0 border-l-0 text-primary-red  text-lg font-bold">
              अव बृद्धि हुने जारी तथा चुक्ता पुँजीः
            </label>
            <input
              type="text"
              placeholder=""
              {...register("issued_and_paid_up_capital", { required: false })}
              className=" text-primary-blue md:w-[40%] flex-shrink-0 m-0  py-3 px-3 outline-none"
            />
          </div>
        </div>

        {/* first one clicked */}
        <div className="border-2 bg-pink-100 border-primary-blue mt-3">
          <p className="text-primary-blue mt-0 text-base font-Laila font-semibold leading-10 text-center">
            अब बृद्धि हुने अधिकृत पुँजीको आधारमा कम्पनीको पुँजी बृद्धि सम्बन्धि
            काम गर्दा तपाईको जम्मा लाग्ने रकम रु.१५,०००।– मात्र ।
          </p>
        </div>
        {/* first one clicked closed*/}

        {/* note */}
        <div className=" border-primary-blue mt-3">
          <div className="flex text-primary-blue mt-0 font-semibold leading-10 text-center">
            <p className=" text-primary-red mr-2">नोट :</p> माथी उल्लेखित रकम ७
            जना सम्म शेयर सदस्यहरु भएमा मात्र लागु हुनेछ, यदि ७ जना भन्दा बढि
            भएमा प्रती सदस्य रु.५००।–को दरले थप शुल्क बृद्धि हुदै जानेछ ।
          </div>
        </div>
      </div>
      {/*note closed */}
      {/* new company for 3 months close */}
      <div className="text-primary-blue  font-Calistoga text-lg underline my-4">

        <p className="text-primary-blue underline font-Laila"><span className="font-Calistoga"> 2. Upload Document </span>माथी ३ महिने विवरण पेश गर्नको लागि आवश्यक पर्ने निम्न कागजपत्रहरु{" "} <span className=" text-primary-red px-2 underline">Upload</span> गर्नुहोस ।
        </p>
      </div>


      {/* upload documents open */}

      <Documents
        documents_data={upload_document_v2}
        initialState={data_v2}
        setDocument={setDocsOutput}
      />
      {/* upload documents close */}
      <div className="text-primary-blue font-Calistoga  text-lg my-5 mb-6 underline">
        3. Working Branch
        <span className="text-primary-blue font-Laila underline mx-2 ">
          (तपाईले दर्ता गर्न खोज्नुभएको कम्पनी रहने ठेगाना नजिक हाम्रो कुन शाखा नजिक पर्छ छनोट गर्नुहोस् ।)
        </span>
      </div>
      <FormBranch register={register} />

      <FormButtom/>
      <NewFormPayment
        handleSubmit={handleSubmit} handleClick={handleSub}
        setUploadProof={setUploadProof}
      />

    </form>
  );
};

export default NewCmpCapital;
